export default __webpack_public_path__ + "static/media/marketing.1ab5781e.svg";